import React from "react";
import { Button } from "react-bootstrap";

interface SelectEmptyStateProps {
    message: string;
    actionLabel?: string;
    onActionClick?: () => void;
    actionIconClassName?: string | null;
}

export const SelectEmptyState: React.FC<SelectEmptyStateProps> = ({
    message,
    actionLabel,
    onActionClick,
    actionIconClassName = "bi-plus-lg",
}) => {
    const hasAction = !!actionLabel && !!onActionClick;

    return (
        <div className="d-flex flex-column align-items-center justify-content-center text-center">
            <span className="text-grey fs-16">{message}</span>
            {hasAction && (
                <Button variant="link" className="p-0 text-primary fs-16 text-decoration-none" onClick={onActionClick}>
                    {actionIconClassName && <i className={`bi ${actionIconClassName} me-1`}></i>}
                    {actionLabel}
                </Button>
            )}
        </div>
    );
};
